<template>
  <div class="mainfooter _mainfooter">
    <div class="footerbottom _footerbottom">
      <div class="text">
        <p class="address fs">
          金双诚门业 全国免费服务热线：400-100-6767 传真：0395-6150116
          地址：中国漯河郾城区孟庙镇纬10路1号
        </p>
        <p class="copyright fs">
          Copyright 2012-2015©lhtianan.com.cn company All right reserved
          版权所有漯河江山天安新型建材有限公司
        </p>
        <p class="fs">备案编号：<a href="https://beian.miit.gov.cn">豫ICP备19000991号</a></p>
      </div>
      <div class="qrCode">
        <img
          src="https://mp.weixin.qq.com/mp/qrcode?scene=10000004&size=102&__biz=MzA5ODE0NTIzNg==&mid=2668127860&idx=4&sn=0e0c73a6b28463b8e0e7950abe9f13e7&send_time="
          alt=""
        />
        <p>微信扫一扫</p>
        <p>关注该公众号</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainfooter",
  components: {},
};
</script>

<style lang="less" scoped>
a{
  color: #fff;
  text-decoration: none;
}
.mainfooter {
  background-color: #0e0e0e;
  color: #fff;

  .footerbottom {
    padding-bottom: 20px;
    height: 180px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .text{
    }
    .address {
      width: 100%;
      height: 40px;
      text-align: center;
      line-height: 40px;
      // border-bottom: 1px solid #eee;
    }

    .options-foot {
      line-height: 50px;
      cursor: pointer;
    }

    .copyright {
      margin-bottom: 8px;
      line-height: 30px;
    }
    .fs {
      font-size: 16px;
    }
    .qrCode {
      position: absolute;
      right: 20px;
      bottom: 20px;
      width: 150px;
      text-align: center;
      // background-color: #fff;
      img {
        width: 102px;
        height: 102px;
      }
      p {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}

@media only screen and (min-width: 800px) {
  .mainfooter {
    display: flex;
    flex-direction: column;
    width: 100%;

    .footerbody {
      display: flex;
      justify-content: space-around;
      text-align: left;
      padding: 20px 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      margin: 0 10%;

      div {
        width: 130px;

        h1 {
          font-size: 12px;
          font-weight: 800;
          margin: 7px 0;
        }

        p {
          font-size: 10px;
          margin: 7px 0;
        }
      }
    }

    .footerbottom {
      margin: 7px 0;

      p {
        font-size: 10px;
      }
    }
  }
}

@media only screen and (max-width: 800px) {
  ._mainfooter {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: start;

    ._footerbody {
      width: 100%;
      display: flex;
      justify-content: space-around;
      text-align: left;
      // padding: 20px 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      // height: 500px;
      display: flex;
      flex-direction: column;
      align-items: center;

      // margin:0 10%;
      div {
        margin: 0 10px;
        width: 95%;

        h1 {
          display: block;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          color: rgba(0, 0, 0, 0.5);
          height: 40px;
          font-size: 10px;
          font-weight: 800;
          line-height: 40px;
          // margin: 7px 0;
        }

        p {
          display: none;
          font-size: 10px;
          margin: 7px 0;
        }
      }
    }

    ._footerbottom {
      margin: 7px 0;

      p {
        font-size: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue